import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BaseHttpService } from '../shared/services/basehttp.service';
import {
  ButtonColors,
  ButtonSize,
  ButtonStyle,
  ButtonType,
} from '../shared/components/inputs/button/button.model';
import { LoginModel } from '../login/login.model';
import { Constants } from '../shared/constants';
import { NotificationService } from '../shared/services/notifications.service';
import { AuthService } from '../auth/auth.service';
import { LogoutServive } from '../logout/logout.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import forge from 'node-forge';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../shared/services/token-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { MenubarService } from '../shared/services/menunavbar.services';
import { UserServiceService } from '../user/survey-main/service/user-service.service';
import { AUTH_SERVICE } from '../auth/auth.token';
import type {
  IAuthService,
  IAuthUser,
} from '../auth/auth.interface';
import { environment } from 'src/environments/environment';
import { PostLoginService } from '../shared/services/post-login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  UserLoggedIn: boolean = false;

  authUser: IAuthUser;

  readonly isKeycloakProvider =
    environment.authProvider === 'keycloak';

  constants: Constants = new Constants();

  constructor(
    private baseHttpService: BaseHttpService,
    private router: Router,
    private notificationService: NotificationService,
    private authService: AuthService,
    private logoutservice: LogoutServive,
    private globalsessionhandler: GlobalsessionhandlerService,
    private spinnerService: NgxSpinnerService,
    private tokenStorage: StorageService,
    @Inject(AUTH_SERVICE)
    private authSvc: IAuthService,
    private dialog: MatDialog,
    private menubarService: MenubarService,
    private userService: UserServiceService,
    private sessionHandlerService: GlobalsessionhandlerService,
    private postLoginService: PostLoginService
  ) {
    this.authUser = {} as IAuthUser;
  }

  async loadAccessPermission() {
    try {
      this.globalsessionhandler.clearSession();
    } catch (error) {
      this.logError(
        'Access permission setup failed',
        error
      );
    }
  }

  ngOnInit() {
    try {
      this.logoutservice.currentUserLogin.subscribe({
        next: (message) => {
          try {
            this.UserLoggedIn = message;

            if (
              this.authSvc.isTokenValid() &&
              this.UserLoggedIn
            ) {
              this.logoutservice.setUserLoginStatus(
                true
              );

              this.UserLoggedIn = true;

              this.logoutservice.changeMessage(
                this.UserLoggedIn
              );

              this.menubarService.updatedDataSelection(
                true
              );

              this.logoutservice.setUserLoginStatus(
                true
              );

              this.router.navigate([
                '/homePage',
              ]);
            } else {
              this.logoutservice.changeMessage(
                this.UserLoggedIn
              );
            }
          } catch (error) {
            this.logError(
              'Login state processing failed',
              error
            );
          }
        },
        error: (error) => {
          this.logError(
            'Login state subscription failed',
            error
          );
        },
      });
    } catch (error) {
      this.logError(
        'Login initialization failed',
        error
      );
    }
  }

  LoginHeading: string = 'Sign in';

  placeHolderText = 'Username';

  isMultiLine = false;
  regbtnText = 'Sign in';
  btnXlarge = ButtonSize.Xlarge;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  btnregText = 'CREATE AN ACCOUNT';
  btnWhite = ButtonColors.White;

  constant: Constants = new Constants();

  login: LoginModel = {
    Username: null,
    Password: null,
  };

  keyDownFunction(
    event: any,
    form: NgForm
  ) {
    try {
      if (event.keyCode == 13) {
        this.userSignIn(form);
      }
    } catch (error) {
      this.logError(
        'Login key handling failed',
        error
      );
    }
  }

  LoginAuth(form: NgForm) {
    try {
      this.login.Username =
        form.controls.username.value;

      this.login.Password =
        form.controls.password.value;

      const loginModel =
        this.login;

      if (
        this.login.Username == '' ||
        this.login.Username == null ||
        this.login.Password == null ||
        this.login.Password == ''
      ) {
        this.notificationService.showError(
          'Please enter login credentials',
          'Error'
        );

        return;
      }

      const rsa =
        forge.pki.publicKeyFromPem(
          this.constant.publicKey
        );

      const encryptedPwd =
        window.btoa(
          rsa.encrypt(
            loginModel.Password,
            'RSA-OAEP',
            {
              md: forge.md.sha1.create(),
            }
          )
        );

      const encryptedEmail =
        window.btoa(
          rsa.encrypt(
            loginModel.Username,
            'RSA-OAEP',
            {
              md: forge.md.sha1.create(),
            }
          )
        );

      loginModel.Password =
        encryptedPwd;

      loginModel.Username =
        encryptedEmail;

      this.spinnerService.show();

      this.baseHttpService
        .post(
          this.constant.postlogin,
          loginModel
        )
        .subscribe({
          next: async (result) => {
            try {
              if (result != null) {
                this.tokenStorage.saveToken(
                  result.auth_token
                );

                this.tokenStorage.saveRefreshToken(
                  result.refresh_token
                );

                this.tokenStorage.saveUser(
                  result
                );

                this.tokenStorage.set(
                  'token',
                  result.auth_token
                );

                this.tokenStorage.set(
                  'refresh_token',
                  result.refresh_token
                );

                this.globalsessionhandler.clearSession();

                this.notificationService.showSuccess(
                  'You have successfully logged in.',
                  'Login successful!'
                );

                await this.loadAccessPermission();

                this.globalsessionhandler.emitloginSucessful(
                  true
                );

                this.UserLoggedIn = true;

                this.logoutservice.changeMessage(
                  this.UserLoggedIn
                );
              } else {
                this.notificationService.showError(
                  'Please enter correct UserName and Password',
                  'Login failed'
                );

                this.authService.removeToken();

                this.UserLoggedIn = false;
              }
            } catch (error) {
              this.logError(
                'Legacy login processing failed',
                error
              );
            } finally {
              this.spinnerService.hide();
            }
          },
          error: (error) => {
            try {
              if (
                error?.error === true
              ) {
                this.notificationService.showError(
                  'User account is logged due to invalid login attempts. Please try after 15 minutes.',
                  'Login failed'
                );
              } else {
                this.notificationService.showError(
                  'Please enter correct UserName and Password',
                  'Login failed'
                );
              }

              this.logError(
                'Legacy login request failed',
                error
              );
            } finally {
              this.spinnerService.hide();
            }
          },
        });
    } catch (error) {
      this.spinnerService.hide();

      this.logError(
        'Legacy login failed',
        error
      );
    }
  }

  Navigate() {
    try {
      this.router.navigate([
        '/',
        'register',
      ]);
    } catch (error) {
      this.logError(
        'Register navigation failed',
        error
      );
    }
  }

  NavigateToForgetPwd() {
    try {
      this.router.navigate([
        '/',
        'forgotpassword',
      ]);
    } catch (error) {
      this.logError(
        'Forgot password navigation failed',
        error
      );
    }
  }

  async userSignIn(
    form: NgForm
  ) {
    try {
      this.spinnerService.show();

      const rawUsername: string =
        form.controls.username &&
        form.controls.username.value;

      const username: string =
        rawUsername == null
          ? rawUsername
          : rawUsername
              .toString()
              .trim();

      const pwd: string =
        form.controls.password.value;

      this.authUser.email =
        username;

      this.authUser.password =
        pwd;

      if (
        username == '' ||
        username == null ||
        pwd == null ||
        pwd == ''
      ) {
        this.notificationService.showError(
          'Please Enter Login Credentials',
          'Error'
        );

        this.spinnerService.hide();

        return;
      }

      this.globalsessionhandler.clearSession();

      await this.signIn();
    } catch (error) {
      this.spinnerService.hide();

      this.logError(
        'User sign in failed',
        error
      );
    }
  }

  async signIn() {
    try {
      await this.authSvc.signIn(
        this.authUser
      );

      await this.postLoginService.handlePostLoginSetup(
        this.authUser.email
      );

      this.UserLoggedIn = true;
    } catch (error) {
      this.logError(
        'Configured provider sign in failed',
        error
      );

      const message =
        error instanceof Error &&
        error.message
          ? error.message
          : 'Login failed';

      this.notificationService.showError(
        message,
        'Error'
      );
    } finally {
      this.spinnerService.hide();
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] = [];

      let currentError: unknown =
        error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message === 'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError = null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(
        context
      );
    }
  }
}